<div class="metadata-dialog" style="min-width: 300px !important;">
  <h2 mat-dialog-title>{{data.title}}</h2>

  <mat-dialog-content>
    <form #form="ngForm">
      @if (!loading) {
        <metadata-panel [ngModelGroup]="data.title" fxFill [model]="data.model"
        [metadata]="data.metadata"></metadata-panel>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="column" fxLayoutAlign="center end">
    @if (loading) {
      <forge-linear-progress></forge-linear-progress>
    }
    <command-bar [commands]="commands" attr.telemetry="Menu-{{data.title}}"></command-bar>
  </mat-dialog-actions>
</div>